import { Toast, useToast } from '@zillow/constellation-10';
import { useEffect } from 'react';
import { downloadPdfUrl, openPdfUrlInNewTab } from '../utils';

export function usePdfHandler({
  pdfUrl,
  openInNewTab = false,
  downloadFilename,
}: {
  pdfUrl?: string;
  openInNewTab?: boolean;
  downloadFilename?: string;
}) {
  const { enqueueToast } = useToast();

  useEffect(() => {
    if (pdfUrl) {
      // in case user wants to open pdf in new tab and download, run these sequentially and clean up only afterwards
      if (openInNewTab) {
        const newWindow = openPdfUrlInNewTab(pdfUrl, false);
        if (!newWindow) {
          enqueueToast(<Toast tone="critical">PDF pop-up was blocked. Please allow pop-ups for this website.</Toast>);
        }
      }
      if (downloadFilename) {
        downloadPdfUrl(pdfUrl, downloadFilename);
      }
    }
  }, [downloadFilename, enqueueToast, openInNewTab, pdfUrl]);
}
